const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  language: state => state.app.language,
  token: state => {
    let userInfo = state.user.userInfo
    if (!userInfo) {
      userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    }
    if (userInfo) {
      return userInfo.token
    }
    return null
  },
  userInfo: state => {
    let userInfo = state.user.userInfo
    if (!userInfo) {
      userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    }
    return userInfo
  },
  isSetRoutes: state => state.user.isSetRoutes,
  permission_routes: state => state.permission.routes,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  entrust: state => state.transfer.entrust,
  evaluateEntrust: state => state.transfer.evaluateEntrust
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js